<template>
    <answers ref="answers"
             code_question_group="GQ22"
             danger_code="MCAL10"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
